import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { apiJson, ApiResponseError } from "../../lib/adminApi";
import type { AdminIdentity } from "../../types/admin";

export function AdminRoute() {
  const [state, setState] = useState<"loading" | "authenticated" | "unauthenticated" | "error">("loading");
  const location = useLocation();
  useEffect(() => {
    apiJson<{ admin: AdminIdentity }>("/api/admin/auth/session")
      .then(() => setState("authenticated"))
      .catch((error) => setState(error instanceof ApiResponseError && error.status === 401 ? "unauthenticated" : "error"));
  }, []);
  if (state === "loading") return <div className="admin-loading" role="status">Checking your secure session…</div>;
  if (state === "unauthenticated") return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  if (state === "error") return <div className="admin-loading" role="alert">The secure session could not be checked. Refresh to try again.</div>;
  return <Outlet />;
}
